<template>
<!-- <div> -->
  <el-dialog
    class="thirdpary-dialog"
    :visible.sync="showBindPhone"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="close-dialog pointer">
      <fps-icon class="close-icon" type="close" />
    </div>
    <div v-if="!isOrder" class="bind-phone-title">{{$t('components_bindphone_index_1096')}}</div>
    <div class="dialog-msg">{{ isOrder ? $t('components_bindphone_index_1097') : $t('components_bindphone_index_1098') }}</div>
    <div class="login-body">
      <div class="login-body-line mobile">
        <div class="mobile-prefix">
          <el-popover
            v-model="isShowMobileAreaSelectList"
            :visible-arrow="false"
            popper-class="popper-clear-style"
            placement="bottom-start"
          >
            <div slot="reference" class="mobile-prefix-inner">
              <span>{{ currentSelectPrefix.code }}</span>
              <img src="~@/assets/images/select-icon.png" alt="" />
            </div>
            <div
              class="login-body-mobile-area"
              v-clickoutside="closeMobileAreaSelectList"
            >
              <p
                v-for="(item, index) in mobileAreaList"
                :key="index"
                @click="selectMobileArea(item.code)"
              >
                <span>{{ item.text }}</span>
                <span>{{ item.code }}</span>
              </p>
            </div>
          </el-popover>
        </div>
        <div class="mobile-input">
          <input
            v-model="loginObj.phoneNumber"
            type="text"
            :placeholder="$t('upgrade_page_views_user_set_account_783')"
          />
        </div>
      </div>
      <div class="login-body-line code">
        <div class="valid-code">
          <input
            v-model="loginObj.verifyCode"
            type="text"
            :placeholder="$t('upgrade_page_views_user_set_account_785')"
          />
        </div>
        <div class="btn">
          <button :class="!sendCodeTimer && !isSendingSmsCode && 'button-hover'" :disabled="sendCodeTimer > 0" @click="getValidateCode">
            <span v-if="isSendingSmsCode">
              <i class="el-icon-loading"></i>{{$t('upgrade_page_views_user_set_account_786')}}</span>
            <span v-else>{{
            sendCodeTimer > 0
                ? $t("components_login_components_phone_login_1077") + sendCodeTimer + ")"
                : $t("upgrade_page_views_user_set_account_787")
            }}</span>
          </button>
        </div>
      </div>
      <div id="verification-code"></div>
      <div
        class="affirm-btn"
        @click="bindPhone"
      >
        <button class="button-hover">{{ isOrder ? $t('components_bindphone_index_1099') : $t('components_bindphone_index_1100') }}</button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import i18n from '@/locales/index'
import mobileAreaList from '@/utils/areas-code'
import Clickoutside from "@/utils/clickoutside"
import { getSmsCode } from "@/api"
import store from '@/store/index'

export default {
  name: 'BindPhone',
  directives: {
    clickoutside: Clickoutside
  },
  filters: {
    splitTime(str) {
      return str ? str.split(' ')[0] : ''
    }
  },
  data() {
    return {
      isSaveToken: true,
      pagelogin: false,
      isHome: false,
      isBanner: false,
      visible: false,
      isShowMobileAreaSelectList: false,
      currentSelectPrefix: {
        code: 1
      },
      loginObj: {
        phoneNumber: "",
        verifyCode: "",
        keyUuid: null,
        isHome: false,
        isBanner: false,
      },
      tencentCaptchaInstance: null,
      isSendingSmsCode: false,
      sendCodeTimer: 0,
      isLogining: false,
      mobileAreaList,
      redirectPath: '',
      isOrder: false,
      isClickOrder: false
    }
  },
  computed: {
    showBindPhone() {
      return this.visible
    },
    eventCategory() {
      return this.isOrder ? 'PurchaseDiscount' : 'ThirdPartyLogin'
    },
  },
  watch: {
    showBindPhone(value) {
      if (value) {
        this.loginObj = {
          phoneNumber: "",
          verifyCode: "",
          keyUuid: null
        }
      } else {
        const userInfo = store.getters.userInfo
        const hasRedBag = userInfo && userInfo.hasRedBag
        const isNewRegistration = userInfo && userInfo.isNewRegistration
        if (hasRedBag && !this.isOrder) {
          store.dispatch('app/showRedbagDialog', 'NEWCOMER_EXPERIENCE')
            .then(() => {
              this.success()
              this.jumpRedirect()
            })
            .catch(() => {
              this.success()
              this.jumpRedirect()
            })
        } else if (userInfo.phoneNumber && userInfo.phoneNumber.substring(0, 3) !== '886' && isNewRegistration) {
          this.$message({
            message: i18n.t('components_login_components_phone_login_1083')
          })
        } else if (!hasRedBag) {
          this.$message({
            message: i18n.t('components_login_components_phone_login_1084')
          })
        }
        if (!hasRedBag && this.isOrder) {
          this.fail()
        }
      }
    },
  },
  methods: {
    fail() {},
    jumpRedirect() {
      if (this.pagelogin) {
        setTimeout(() => {
          location.replace(location.origin + (decodeURIComponent(this.redirectPath) || '/'))
        }, 0)
      }
    },
    bindPhone() {
      // if(this.isHome) {
      //   window.gtag('Login', 'FreeGame', 'Profile')
      // }
      // if(this.isBanner) {
      //   window.gtag('Login', 'FreeGame', 'Banner')
      // }
      const params = this.validateInputMsg()
      if (params && !this.isLogining) {
        this.isLogining = true
        // window.gtag('MobileRegister', this.eventCategory, 'Click')
        this.$http.post('/user/telephone/bind', params).then(rs => {
          //绑定手机号成功人数埋点
          // const userInfo = store.getters.userInfo
          // window.gtag('tel_bind_success',userInfo ? userInfo : 0)
          // window.gtag('MobileRegister', this.eventCategory, 'Click')
          const unLoginAB = window.localStorage.getItem('unLoginHomeABTest')
          if (unLoginAB) {
            // window.gtag('signupab_success', unLoginAB)
          }
          store.dispatch('app/setUserInfo', {
            userInfo: rs.data,
          })
          this.isLogining = false
          this.visible = false
          this.success()
          this.jumpRedirect()
        }).catch(rs => {
          this.isLogining = false
          if (rs.code === 434) {
            this.$message.error(i18n.t('components_bindphone_index_1101'))
          } else if (rs.code === 618) {
            this.$message.error(i18n.t('upgrade_page_views_user_set_account_800'))
          } else {
            this.$message.error(i18n.t('upgrade_page_views_user_set_account_789'))
          }
        })
      }
    },
    closeBindPhone() {
      // window.gtag('MobileRegister', this.eventCategory, 'Close')
      //手机绑定弹窗关闭按钮点击次数埋点
      // const userInfo = store.getters.userInfo
      // window.gtag('tel_number_close_click', userInfo ? userInfo.uuid : 0)
      this.fail()
      this.visible = false
    },
    toggleMobileAreaSelectList() {
      this.isShowMobileAreaSelectList = !this.isShowMobileAreaSelectList
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    success() {

    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      const { phoneNumber, verifyCode, keyUuid } = this.loginObj
      const { code } = this.currentSelectPrefix

      if (!phoneNumber) {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_801'))
        return false;
      }
      if (verifyCode.length !== 4) {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_785'))
        return false;
      }

      return {
        phoneNumber: code + phoneNumber,
        verifyCode,
        keyUuid
      }
    },
    getValidateCode() {
      //获取验证码按钮点击
      // const userInfo = store.getters.userInfo
      // window.gtag('tel_accept_code_click', userInfo ? userInfo.uuid : 0)
      const { phoneNumber } = this.loginObj
      if (!phoneNumber) return this.$message.error(i18n.t('upgrade_page_views_user_set_account_783'))

      if (!this.tencentCaptchaInstance) {
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            const { phoneNumber } = this.loginObj
            const { code } = this.currentSelectPrefix

            getSmsCode({
              phoneNumber: code + phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }

              this.isSendingSmsCode = false
            }).catch(err => {
              this.isSendingSmsCode = false
              if (err.msg) {
                if (err.msg === 'InvalidParameterValue.IncorrectPhoneNumber') {
                  this.$message.error(i18n.t('upgrade_page_views_user_set_account_802'))
                  return
                }
                this.$message.error(err.msg)
              }
            })
          }
        })
      }
      this.tencentCaptchaInstance.show()
    },
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count

      if (count > 0) {
        setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      }
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
  }
}
</script>
<style lang="scss" scoped>
.button-hover:hover {
  background: #FEE060 !important;
}
.dialog-msg {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #333333;
}
.dialog-msg-2 {
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #999999;
  margin: 10px 0 31px;
}

.thirdpary-dialog {
  & /deep/ .el-dialog {
    width: 386px;
    border-radius: 8px;
  }
  & /deep/ .el-dialog__header {
    padding: 0;
  }
  & /deep/ .el-dialog__body {
    padding: 40px 0 54px !important;
    position: relative;
    .bind-phone-title {
      padding-bottom: 20px;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      color: #333333;
    }
    .close-dialog {
      position: absolute;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: 2px solid rgb(176, 176, 176);
      @include flex;
      bottom: -84px;
      left: 171px;
      .close-icon {
        font-size: 20px;
        color: rgb(176, 176, 176);
      }
    }
  }
}
.affirm-btn {
  width: 100%;
  height: 46px;
  margin-top: 53px;

  button {
    @include flex();
    width: 100%;
    height: 100%;
    color: white;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    border-radius: 4px;
    cursor: pointer;
    background: $color-yellow;
    color: $color-gray-1;
    &:disabled {
      background: #FFEC9B !important;
      color: rgba(34, 44, 67, 0.3) !important;
    }
  }
}
@media screen and (max-width:599px) {
  .login-body-mobile-area {
    width: 290px;
    max-width: 77vw;
    height: 228px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #999;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    @media screen and (max-width: 320px) {
      width: 75vw;
    }
    p {
      @include flex(space-between);
      color: #333;
      font-size: 16px;
      height: 38px;
      margin: 0;
      padding: 0 9px;
      font-weight: 400;
      transition: all 0.2s ease;
      cursor: pointer;
      background: white;

      &:hover {
        background: #f6f6f6;
      }

      span:first-child {
        @include ellipsis;
      }
    }
  }
  .login-body {
    position: relative;
    padding: 40px 28px 0;
    // border-top: 1px solid #e0e0e0;
  }
  .login-body-line {
    @include flex(space-between,center,row);
    height: 46px;
    border-radius: 4px;
    font-size: 16px;

    > div {
      @include flex();
      height: 100%;
    }

    &.mobile {
      border: 1px solid #999999;
      padding: 0 13px 0 0;
    }

    &.code {
      margin-top: 20px;
    }

    input {
      width: 100%;
      height: 100%;
      color: #333;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }

    .mobile-prefix {
      position: relative;
      width: 55px;
      flex-shrink: 0;
      cursor: pointer;

      .mobile-prefix-inner {
        @include flex(space-between);
        width: 58px;
        padding-left: 13px;
        span {
          font-weight: 500;
          font-size: 16px;
          color: #333333;
        }
      }

      img {
        width: 10px;
        margin-left: 2px;
      }
    }

    .mobile-input {
      flex-grow: 1;
      margin-left: 14px;
      input{
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
      }
    }

    .valid-code {
      width: 48vw;
      border: 1px solid #999;
      border-radius: 4px;
      padding: 0 13px;
    }

    .btn {
      width: 34vw;
      margin-left: 10px;

      button {
        @include flex();
        width: 100%;
        height: 100%;
        color: white;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        border-radius: 4px;
        cursor: pointer;
        background: $color-yellow;
        color: $color-gray-1;
        &:disabled {
          background: #FFEC9B !important;
          color: rgba(34, 44, 67, 0.3) !important;
        }
      }
    }
  }
  .login-body-operation {
    display: inline-block;
    font-size: 0;
    margin-top: 40px;

    p {
      @include flex(flex-start);
      cursor: pointer;
    }

    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }

    span {
      font-size: 13px;
      color: #666;
      line-height: 18px;
    }
  }
  .dialog-msg {
    font-size: 15px;
    line-height: 21px;
  }
  .thirdpary-dialog {
    & /deep/ .el-dialog {
      width: 344px;
    }
    .close-dialog {
      bottom: -88px !important;
      left: 150px !important;
    }
  }
}
@media screen and (min-width: 600px) {
  .login-body-mobile-area {
    width: 290px;
    height: 228px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #999;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    p {
      @include flex(space-between);
      color: #333;
      font-size: 16px;
      height: 38px;
      margin: 0;
      padding: 0 9px;
      font-weight: 400;
      transition: all 0.2s ease;
      cursor: pointer;
      background: white;

      &:hover {
        background: #f6f6f6;
      }

      span:first-child {
        @include ellipsis;
      }
    }
  }
  .login-body {
    position: relative;
    width: 290px;
    margin: 40px auto 0;
    // border-top: 1px solid #e0e0e0;
  }
  .login-body-line {
    @include flex();
    height: 46px;
    border-radius: 4px;
    font-size: 16px;

    > div {
      @include flex();
      height: 100%;
    }

    &.mobile {
      border: 1px solid #999999;
      padding: 0 13px 0 0;
    }

    &.code {
      margin-top: 20px;
    }

    input {
      width: 100%;
      height: 100%;
      color: #333;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }

    .mobile-prefix {
      width: 55px;
      flex-shrink: 0;
      cursor: pointer;

      .mobile-prefix-inner {
        @include flex(space-between);
        width: 58px;
        padding-left: 13px;
        span {
          font-weight: 500;
          font-size: 16px;
          color: #333333;
        }
      }

      img {
        width: 10px;
        margin-left: 2px;
      }
    }

    .mobile-input {
      flex-grow: 1;
      margin-left: 14px;
      input{
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
      }
    }

    .valid-code {
      width: 164px;
      border: 1px solid #999;
      border-radius: 4px;
      padding: 0 13px;
    }

    .btn {
      width: 116px;
      margin-left: 10px;

      button {
        @include flex();
        width: 100%;
        height: 100%;
        color: white;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        border-radius: 4px;
        cursor: pointer;
        background: $color-yellow;
        color: $color-gray-1;
        &:disabled {
          background: #FFEC9B !important;
          color: rgba(34, 44, 67, 0.3) !important;
        }
      }
    }
  }

  .login-body-operation {
    display: inline-block;
    font-size: 0;
    margin-top: 40px;

    p {
      @include flex(flex-start);
      cursor: pointer;
    }

    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }

    span {
      font-size: 13px;
      color: #666;
      line-height: 18px;
    }
  }
} 
</style>